import { useContext } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import CommunityPostFormContainer from '../Post/CommunityPostFormContainer';

import CommunityHeaderComponent from './CommunityHeaderComponent';

import { onModalClose, showRenderPropsModal } from '../../Modal/actions';

import { checkHasPermissions, isAdmin } from '../../../utils';
import { getCommunityPostsQuery } from '../utils';

import { AVOID_STATUSES, COMMUNITY_POST_TYPES } from '../constants';

import permissions from '../../../permissions';
import CommunityContext from '../context';

const CommunityHeaderContainer = ({
  community,
  onCommunityChange,
  communityOptions,
  search,
  setSearch,
  openModal,
  closeModal,
  communityType,
}) => {
  const { t } = useTransl();
  const checkIfCommunityMember = useContext(CommunityContext);
  const queryParams = getCommunityPostsQuery(
    search,
    community?.value,
    communityType,
    AVOID_STATUSES, // we don't want to show content with AVOID_STATUSES approvalStatus
  );

  const onCreatePost = (title, type) => {
    if (!checkIfCommunityMember()) return;
    openModal({
      title,
      maxWidth: 'md',
      closeModal,
      render: () => (
        <CommunityPostFormContainer
          currentCommunityId={community?.value}
          type={type}
          queryParams={queryParams}
        />
      ),
    });
  };

  const communityActions = [
    {
      label: t('community.post'),
      onClick: () =>
        onCreatePost(t('community.post'), COMMUNITY_POST_TYPES.post),
    },
    {
      label: t('title.recommendation'),
      onClick: () =>
        onCreatePost(
          t('community.createRecommendation'),
          COMMUNITY_POST_TYPES.recommendation,
        ),
    },
    {
      label: t('community.marketplaceItem'),
      onClick: () =>
        onCreatePost(
          t('community.createMarketplaceItem'),
          COMMUNITY_POST_TYPES.marketplace,
        ),
    },
  ];

  const isAddButtonShown =
    checkHasPermissions(permissions.create_community_post) && !isAdmin();

  return (
    <CommunityHeaderComponent
      community={community}
      onCommunityChange={onCommunityChange}
      communityOptions={communityOptions}
      search={search}
      setSearch={setSearch}
      communityActions={isAddButtonShown ? communityActions : []}
    />
  );
};

CommunityHeaderContainer.propTypes = {
  community: PropTypes.instanceOf(Object).isRequired,
  onCommunityChange: PropTypes.func.isRequired,
  communityOptions: PropTypes.instanceOf(Array).isRequired,
  setSearch: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  communityType: PropTypes.string.isRequired,
  search: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  openModal: (props) => showRenderPropsModal(dispatch, props),
  closeModal: () => onModalClose(dispatch),
});

export default connect(null, mapDispatchToProps)(CommunityHeaderContainer);
